import { buildReducer } from '../../utils/redux/getReduxModuleByFeatureName';
import { LOCATION_CHANGE } from 'connected-react-router';
import { matchPath } from 'connected-react-router';
import getConstantsByFeatureName from '../../utils/redux/getConstantsByFeatureName';
import getActionCreators from '../../utils/redux/getActionCreators';
import getActionHandlers from '../../utils/redux/getActionHandlers';
import { initialState, addItemToData } from '../../utils/redux/commonActionHandlers';
import getSelectorByFeatureName from '../../utils/redux/getSelectorByFeatureName';


export const constants = getConstantsByFeatureName('CREW_USER_VESSELS');
export const actions = getActionCreators(constants);
export const reducer = buildReducer(initialState, {
  ...getActionHandlers(constants),
  [LOCATION_CHANGE]: (state, { payload: { location: { pathname } } }) => (
    matchPath(pathname, { path: '/crew-users/:id/details' })
      ? state
      : initialState
  ),
  [constants.ADD_CREATED_ITEM]: (state, action) => {
    const newState = addItemToData(state, action);

    return { ...newState, data: newState.data.sort((a, b) => a.createdAt - b.createdAt) };
  },
});
export const selector = getSelectorByFeatureName('crewUserVessels');
